import React from "react";
import BeamerHelmet from "./beamerHelmet";
import { IconButton } from "@mui/material";
import { RiMegaphoneLine } from "react-icons/ri";
import { ReleaseFlag, useReleaseManagement } from "../../../../../utility/feature-management";
import styles from "./updates.module.css";

export type IBeamerConfig = {
  product_id: string;
  selector: string;
  display: string;
  top?: number;
  right?: number;
  button_position: string;
  language: string;
  filter: string;
  lazy: boolean;
  alert: boolean;
  multi_user: boolean;
  bounce: boolean;
  callback?: (val: number) => void;

  //---------------Visitor Information---------------
  user_id?: string;
}

const UpdatesButton: React.FC = () => {
  return (
    <IconButton className={`launchBeamer ${styles.active}`}>
      <RiMegaphoneLine />
    </IconButton>
  );
}

const Updates: React.FC = () => {
  const isFeatureUpdatesReleased = useReleaseManagement(ReleaseFlag.releaseFeatureUpdates);

  if (!isFeatureUpdatesReleased) {
    return <></>
  }

  return (
    <>
      <BeamerHelmet />
      <UpdatesButton />
    </>
  );
}

export default Updates;
